import { Organization } from '../interfaces/api/organization';
import axios from 'axios';

export interface OrganizationFilterParameters {
	status?: 'Online' | 'Offline';
	search?: string;
	ordering?: string;
	fields?: string;
}

function queryBuilderOrganization(parameters: OrganizationFilterParameters): URLSearchParams {
	const queryParameters = new URLSearchParams();
	if (parameters.status) {
		queryParameters.append('status', parameters.status);
	}
	if (parameters.search) {
		queryParameters.append('search', parameters.search);
	}
	if (parameters.ordering) {
		queryParameters.append('ordering', parameters.ordering);
	}
	if (parameters.fields) {
		queryParameters.append('fields', parameters.fields);
	}
	return queryParameters;
}

export async function getOrganizations(
	parameter: OrganizationFilterParameters = {},
	signal?: AbortSignal
): Promise<Organization[]> {
	try {
		const queryParameters = queryBuilderOrganization(parameter);
		const response = await axios.get<Organization[]>('api/organizations/', {
			params: queryParameters,
			signal,
		});
		return response.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response?.data;
		}
		throw error;
	}
}
